class ErlyvideoPlayer {

    /**
     * Настройки плеера поумолчанию
     * @type {{}}
     */
    static defaultParams = {

        /**
         * Запускает плеер во весь экран
         * не зависимо от контейнера
         *
         * @type {boolean}
         */
        fullScreen: true,

        /**
         * Автоматическое воспроизведение
         *
         * @type {boolean}
         */
        autoplay: true,

        /**
         * Заголовок плейлиста
         *
         * @type {string}
         */
        playlistTitle: '',

        /**
         * Файл|Списое файлов|Группы
         *
         * @type {string|array|object}
         */
        src: '',

        /**
         * Индекс файла который первый вопроизводится
         *
         * @type {int}
         */
        startFile: 0,

        viewTitle: '',
        playlistView: '',
        fullPanel: true,
        autoSwitch: true,
        callPlaylistCallback: undefined
    };

    /**
     * Запустить плеер
     *
     * @param params
     */
    static init(params = {}) {
        let video = this.render();
        video.videoPlayer(this.defaultParams, false);
    }

    /**
     * Отрисоавать плеер
     *
     * Контейнер в который вставить плеер
     * Если параметр не указан, то плеер вставляется в корень докуимента
     * @param bodyElement
     * @return {jQuery|HTMLElement}
     */
    static render(bodyElement = false) {
        let videoWrapper = $('<div class="video-player bvideo"></div>');
        let video = $('<video></video>');
        videoWrapper.html(video);

        if(!bodyElement)
            $('body').append(videoWrapper);
        else
            bodyElement.append(videoWrapper);

        return video.videoPlayer(this.defaultParams, false);
    }
}

export default ErlyvideoPlayer;